/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { FinancialChartDropDownControlViewModel } from "./FinancialChartDropDownControlViewModel";
import { markType } from "igniteui-react-core";
import { stringIsNullOrWhiteSpace } from "igniteui-react-core";
/**
 * @hidden
 */
var FinancialChartIndicatorMenuViewModel = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(FinancialChartIndicatorMenuViewModel, _super);
    function FinancialChartIndicatorMenuViewModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.j = null;
        _this.k = null;
        _this.l = 0;
        _this.i = 0;
        _this.m = "Indicators";
        _this.n = "Standalone Indicators";
        _this.o = "Overlays";
        _this.p = "Trendlines";
        _this.q = "Volumes";
        _this.r = "Absolute Volume Oscillator";
        _this.s = "Accumulation Distribution";
        _this.t = "Average Directional Index";
        _this.u = "Average True Range";
        _this.v = "Bollinger Band Width";
        _this.w = "Chaikin Oscillator";
        _this.x = "Chaikin Volatility";
        _this.y = "Commodity Channel Index";
        _this.z = "Detrended Price Oscillator";
        _this.aa = "Ease Of Movement";
        _this.ab = "Fast Stochastic Oscillator";
        _this.ac = "Force Index";
        _this.ad = "Full Stochastic Oscillator";
        _this.ae = "Market Facilitation Index";
        _this.af = "Mass Index";
        _this.ag = "Median Price";
        _this.ah = "Money Flow Index";
        _this.ai = "MACD";
        _this.aj = "Negative Volume Index";
        _this.ak = "On Balance Volume";
        _this.al = "Percentage Price Oscillator";
        _this.am = "Percentage Volume Oscillator";
        _this.an = "Positive Volume Index";
        _this.ao = "Price Volume Trend";
        _this.ap = "ROC";
        _this.aq = "RSI";
        _this.ar = "Slow Stochastic Oscillator";
        _this.as = "Standard Deviation";
        _this.at = "Stoch RSI";
        _this.au = "TRIX";
        _this.av = "Typical Price";
        _this.aw = "Ultimate Oscillator";
        _this.ax = "Weighted Closez";
        _this.ay = "Williams %R";
        _this.az = "Bollinger Bands";
        _this.a0 = "Price Channel";
        _this.a1 = "Cubic Fit";
        _this.a2 = "Cumulative Average";
        _this.a3 = "Exponential Average";
        _this.a4 = "Exponential Fit";
        _this.a5 = "Linear Fit";
        _this.a6 = "Logarithmic Fit";
        _this.a7 = "Modified Average";
        _this.a8 = "PowerLaw Fit";
        _this.a9 = "Quadratic Fit";
        _this.ba = "Quartic Fit";
        _this.bb = "Quintic Fit";
        _this.bc = "Simple Average";
        _this.bd = "Weighted Average";
        _this.be = "Area";
        _this.bf = "Column";
        _this.bg = "Line";
        return _this;
    }
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorMenu_Header", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.t) ? this.a.t : this.m;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Overlay_BollingerBands", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a6) ? this.a.a6 : this.az;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Overlay_PriceChannel", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a7) ? this.a.a7 : this.a0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorMenu_IndicatorsCategoryHeader", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.u) ? this.a.u : this.n;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorMenu_OverlaysCategoryHeader", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.v) ? this.a.v : this.o;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorMenu_TrendlinesCategoryHeader", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.w) ? this.a.w : this.p;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorMenu_VolumeCategoryHeader", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.x) ? this.a.x : this.q;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_AbsoluteVolumeOscillator", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.y) ? this.a.y : this.r;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_AccumulationDistribution", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.z) ? this.a.z : this.s;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_AverageDirectionalIndex", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.aa) ? this.a.aa : this.t;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_AverageTrueRange", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ab) ? this.a.ab : this.u;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_BollingerBandWidth", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ac) ? this.a.ac : this.v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_ChaikinOscillator", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ad) ? this.a.ad : this.w;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_ChaikinVolatility", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ae) ? this.a.ae : this.x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_CommodityChannelIndex", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.af) ? this.a.af : this.y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_DetrendedPriceOscillator", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ag) ? this.a.ag : this.z;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_EaseOfMovement", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ah) ? this.a.ah : this.aa;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_FastStochasticOscillator", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ai) ? this.a.ai : this.ab;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_ForceIndex", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.aj) ? this.a.aj : this.ac;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_FullStochasticOscillator", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ak) ? this.a.ak : this.ad;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_MarketFacilitationIndex", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.al) ? this.a.al : this.ae;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_MassIndex", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.am) ? this.a.am : this.af;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_MedianPrice", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.an) ? this.a.an : this.ag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_MoneyFlowIndex", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ao) ? this.a.ao : this.ah;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_MovingAverageConvergenceDivergence", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ap) ? this.a.ap : this.ai;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_NegativeVolumeIndex", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.aq) ? this.a.aq : this.aj;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_OnBalanceVolume", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ar) ? this.a.ar : this.ak;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_PercentagePriceOscillator", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.as) ? this.a.as : this.al;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_PercentageVolumeOscillator", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.at) ? this.a.at : this.am;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_PositiveVolumeIndex", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.au) ? this.a.au : this.an;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_PriceVolumeTrend", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.av) ? this.a.av : this.ao;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_RateOfChangeAndMomentum", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.aw) ? this.a.aw : this.ap;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_RelativeStrengthIndex", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ax) ? this.a.ax : this.aq;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_SlowStochasticOscillator", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ay) ? this.a.ay : this.ar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_StandardDeviation", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.az) ? this.a.az : this.as;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_StochRSI", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a0) ? this.a.a0 : this.at;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_TRIX", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a1) ? this.a.a1 : this.au;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_TypicalPrice", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a2) ? this.a.a2 : this.av;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_UltimateOscillator", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a3) ? this.a.a3 : this.aw;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_WeightedClose", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a4) ? this.a.a4 : this.ax;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Indicator_WilliamsPercentR", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a5) ? this.a.a5 : this.ay;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_CubicFit", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a8) ? this.a.a8 : this.a1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_CumulativeAverage", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.a9) ? this.a.a9 : this.a2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_ExponentialAverage", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.ba) ? this.a.ba : this.a3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_ExponentialFit", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bb) ? this.a.bb : this.a4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_LinearFit", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bc) ? this.a.bc : this.a5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_LogarithmicFit", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bd) ? this.a.bd : this.a6;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_ModifiedAverage", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.be) ? this.a.be : this.a7;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_PowerLawFit", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bf) ? this.a.bf : this.a8;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_QuadraticFit", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bg) ? this.a.bg : this.a9;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_QuarticFit", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bh) ? this.a.bh : this.ba;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_QuinticFit", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bi) ? this.a.bi : this.bb;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_SimpleAverage", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bj) ? this.a.bj : this.bc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_TrendLine_WeightedAverage", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bk) ? this.a.bk : this.bd;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Volume_Area", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bl) ? this.a.bl : this.be;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Volume_Column", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bm) ? this.a.bm : this.bf;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FinancialChartIndicatorMenuViewModel.prototype, "financialChart_IndicatorsMenu_Volume_Line", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.a.bn) ? this.a.bn : this.bg;
        },
        enumerable: false,
        configurable: true
    });
    FinancialChartIndicatorMenuViewModel.$t = markType(FinancialChartIndicatorMenuViewModel, 'FinancialChartIndicatorMenuViewModel', FinancialChartDropDownControlViewModel.$);
    return FinancialChartIndicatorMenuViewModel;
}(FinancialChartDropDownControlViewModel));
export { FinancialChartIndicatorMenuViewModel };
